module.exports = __webpack_public_path__ + "img/rectangle-fill-orange.2174a709.svg";